import React, { Component } from 'react';
import axios from 'axios';
import Select from 'react-select';
import $ from 'jquery';
import 'bootstrap';
import { store } from 'react-notifications-component';
import PropTypes from 'prop-types';

import '../tools/css/ModalCrearPaciente.css';

const ApiURL = process.env.REACT_APP_API_URL;

const GENEROS = [
  { value: 'F', label: 'Femenino' },
  { value: 'M', label: 'Masculino' }
];

const MESES = [
  { value: 1, label: 'Enero' }, { value: 2, label: 'Febrero' }, { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' }, { value: 5, label: 'Mayo' }, { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' }, { value: 8, label: 'Agosto' }, { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' }, { value: 11, label: 'Noviembre' }, { value: 12, label: 'Diciembre' }
];

const ESTADOS_CIVILES = ['Casado(a)', 'Divorciado(a)', 'Soltero(a)', 'Unión libre', 'Viudo(a)']
  .map((v) => ({ value: v, label: v }));

const PARENTESCOS = [
  'Abuelo(a)', 'Compañero(a)', 'Esposo(a)', 'Hermano(a)', 'Hijo(a)', 'Madre', 'Nieto(a)',
  'Ninguno', 'Nuera', 'Padre', 'Primo(a)', 'Sobrino(a)', 'Tio(a)', 'Yerno'
].map((v) => ({ value: v, label: v }));

function generarDias() {
  const dias = [];
  for (let d = 1; d <= 31; d++) dias.push({ value: d, label: String(d) });
  return dias;
}

function generarAnios() {
  const anioActual = new Date().getFullYear();
  const anios = [];
  for (let a = anioActual; a >= 1910; a--) anios.push({ value: a, label: String(a) });
  return anios;
}

const DIAS = generarDias();
const ANIOS = generarAnios();

// Todos los campos del formulario son obligatorios excepto: segundo nombre,
// segundo apellido, nombre del responsable, parentesco y teléfono del
// responsable. Si al guardar falta alguno de estos, no se bloquea: se pide
// confirmación (ver guardarPaciente/calcularCamposFaltantes).
const CAMPOS_REQUERIDOS = [
  { clave: 'tipoId', etiqueta: 'Tipo de identificación', tipo: 'select' },
  { clave: 'identification', etiqueta: 'Número de identificación', tipo: 'texto' },
  { clave: 'name1', etiqueta: 'Primer nombre', tipo: 'texto' },
  { clave: 'lastName1', etiqueta: 'Primer apellido', tipo: 'texto' },
  { clave: 'gender', etiqueta: 'Género', tipo: 'select' },
  { clave: 'fechaNacimiento', etiqueta: 'Fecha de nacimiento', tipo: 'fecha' },
  { clave: 'email', etiqueta: 'Correo electrónico', tipo: 'texto' },
  { clave: 'phone', etiqueta: 'Teléfono', tipo: 'texto' },
  { clave: 'address', etiqueta: 'Dirección', tipo: 'texto' },
  { clave: 'departmentId', etiqueta: 'Departamento', tipo: 'select' },
  { clave: 'municipalityId', etiqueta: 'Municipio', tipo: 'select' },
  { clave: 'activityId', etiqueta: 'Ocupación', tipo: 'select' },
  { clave: 'civilStatus', etiqueta: 'Estado civil', tipo: 'select' },
  { clave: 'epsId', etiqueta: 'EPS', tipo: 'select' },
  { clave: 'regimenId', etiqueta: 'Régimen', tipo: 'select' }
];

// Datos del acudiente: normalmente opcionales, pero se vuelven obligatorios
// cuando el paciente es menor de 18 o mayor de 70 años (ver calcularEdad).
const CAMPOS_RESPONSABLE = [
  { clave: 'personInCharge', etiqueta: 'Nombre del responsable', tipo: 'texto' },
  { clave: 'relationshipPerson', etiqueta: 'Parentesco', tipo: 'select' },
  { clave: 'phonePerson', etiqueta: 'Teléfono del responsable', tipo: 'texto' }
];

// Reglas RIPS de tipo de documento por edad, solo para colombianos (código
// del TypeIdentification -> a partir de qué edad exacta deja de ser válido):
//   0 a 3 meses y 29 días..... RC ó CN
//   3 meses y 29 días a 7 años RC
//   7 años a 18 años.......... TI (se acepta RC hasta 7a 11m 29d)
//   18 años en adelante....... CC (se acepta TI hasta 18a 11m 29d)
const ETIQUETAS_DOC_COLOMBIA = {
  RC: 'Registro Civil (RC)',
  CN: 'Certificado de Nacido Vivo (CN)',
  TI: 'Tarjeta de Identidad (TI)',
  CC: 'Cédula de Ciudadanía (CC)'
};

// Los documentos de extranjero no tienen restricción de edad: se detectan
// por el texto de la descripción (no todos los backends usan el mismo code).
const PALABRAS_DOCUMENTO_EXTRANJERO = [
  'pasaporte',
  'carnet diplomático', 'carnet diplomatico',
  'salvoconducto de permanencia',
  'permiso especial de permanencia',
  'documento extranjero',
  'permiso temporal de permanencia',
  'pep tutor'
];

function esDocumentoExtranjero(etiqueta) {
  if (!etiqueta) return false;
  const normalizada = etiqueta.toLowerCase();
  return PALABRAS_DOCUMENTO_EXTRANJERO.some((palabra) => normalizada.includes(palabra));
}

// Para que el menú del react-select no quede recortado por el scroll interno
// del modal (modal-dialog-scrollable), se pinta en un portal sobre <body>.
const selectPropsComunes = {
  classNamePrefix: 'select',
  placeholder: 'Seleccione...',
  isClearable: true,
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) }
};

function formInicial() {
  return {
    tipoId: null,
    identification: '',
    name1: '',
    name2: '',
    lastName1: '',
    lastName2: '',
    gender: null,
    dia: null,
    mes: null,
    anio: null,
    email: '',
    phone: '',
    address: '',
    departmentId: null,
    municipalityId: null,
    activityId: null,
    civilStatus: null,
    personInCharge: '',
    relationshipPerson: null,
    phonePerson: '',
    epsId: null,
    regimenId: null
  };
}

/**
 * Modal reutilizable para pre-registrar un paciente (POST /api/Patients/PreRegister)
 * desde cualquier pantalla. Renderízalo una vez en la página y abre el modal con
 * data-toggle="modal" data-target="#modal-crear-paciente" (o $('#modal-crear-paciente').modal('show')).
 * Al guardar con éxito se limpia el formulario, se cierra el modal y se llama
 * onPacienteCreado(paciente) con los datos enviados + lo que responda el backend.
 */
class ModalCrearPaciente extends Component {

  constructor() {
    super();
    this.state = {
      guardando: false,
      buscandoPaciente: false,
      pacienteExistente: false,
      cargandoMunicipios: false,
      tiposId: [],
      departamentos: [],
      municipios: [],
      actividades: [],
      epsList: [],
      regimenes: [],
      idsRelacionPendientes: null,
      form: formInicial()
    };
  }

  componentDidMount() {
    this.cargarListas();
    // Cubre cualquier forma de cerrar el modal (botones, Escape, backdrop),
    // no solo el click en "Cerrar"/×, para que siempre quede reiniciado.
    $('#modal-crear-paciente').on('hidden.bs.modal', this.resetForm);
  }

  componentWillUnmount() {
    $('#modal-crear-paciente').off('hidden.bs.modal', this.resetForm);
  }

  cargarListas = () => {
    axios.get(ApiURL + "/api/TypeIdentification/ListTypeIdentification/paciente")
      .then((response) => {
        const opciones = (response.data || []).map((item) => ({ value: item.code, label: item.description }));
        this.setState({ tiposId: opciones });
      })
      .catch((error) => console.log(error));

    axios.get(ApiURL + "/api/Departments/ListDepartments")
      .then((response) => {
        const opciones = (response.data || []).map((item) => ({ value: item.id, label: item.nombre }));
        this.setState({ departamentos: opciones }, this.resolverIdsPendientes);
      })
      .catch((error) => console.log(error));

    axios.get(ApiURL + "/api/Activities/ListAll")
      .then((response) => {
        console.log('Activities/ListAll:', response.data);
        const opciones = (response.data || []).map((item) => ({
          value: item.id !== undefined ? item.id : (item.activityId !== undefined ? item.activityId : (item.codigo !== undefined ? item.codigo : item.code)),
          label: item.nombre || item.name || item.descripcion || item.description
        }));
        this.setState({ actividades: opciones }, this.resolverIdsPendientes);
      })
      .catch((error) => console.log(error));

    axios.get(ApiURL + "/api/Entities")
      .then((response) => {
        const opciones = (response.data || []).map((item) => ({ value: item.id, label: this.etiquetaEps(item) }));
        this.setState({ epsList: opciones }, this.resolverIdsPendientes);
      })
      .catch((error) => console.log(error));

    axios.get(ApiURL + "/api/Regimes")
      .then((response) => {
        const opciones = (response.data || []).map((item) => ({
          value: item.id,
          label: item.nombre + (item.codigo ? (' - ' + item.codigo) : '')
        }));
        this.setState({ regimenes: opciones }, this.resolverIdsPendientes);
      })
      .catch((error) => console.log(error));
  }

  /**
   * Reintenta ubicar en los catálogos (departamentos/actividades/EPS/régimen)
   * los ids que llegaron de GetPatient antes de que esos catálogos terminaran
   * de cargar (las 5 peticiones de cargarListas van en paralelo, así que no
   * hay garantía de que ya estén listos cuando se busca al paciente).
   */
  resolverIdsPendientes = () => {
    this.setState((previo) => {
      const p = previo.idsRelacionPendientes;
      if (!p) return null;

      const nuevoForm = { ...previo.form };
      let huboCambio = false;

      if (p.departmentId != null && !previo.form.departmentId) {
        const opcion = this.buscarOpcionPorId(previo.departamentos, p.departmentId);
        if (opcion) { nuevoForm.departmentId = opcion; huboCambio = true; }
      }
      if (p.activityId != null && !previo.form.activityId) {
        const opcion = this.buscarOpcionPorId(previo.actividades, p.activityId);
        if (opcion) { nuevoForm.activityId = opcion; huboCambio = true; }
      }
      if (p.epsId != null && !previo.form.epsId) {
        const opcion = this.buscarOpcionPorId(previo.epsList, p.epsId);
        if (opcion) { nuevoForm.epsId = opcion; huboCambio = true; }
      }
      if ((p.regimenId != null || p.regimenNombre) && !previo.form.regimenId) {
        const opcion = this.buscarOpcionPorId(previo.regimenes, p.regimenId) || this.buscarOpcionPorNombre(previo.regimenes, p.regimenNombre);
        if (opcion) { nuevoForm.regimenId = opcion; huboCambio = true; }
      }

      return huboCambio ? { form: nuevoForm } : null;
    });
  }

  /** Arma un label descriptivo por EPS con los campos que el backend traiga disponibles. */
  etiquetaEps = (item) => {
    const partes = [];
    if (item.razonSocial) partes.push(item.razonSocial);
    else if (item.name) partes.push(item.name);
    if (item.nit) partes.push('NIT ' + item.nit);
    return partes.length ? partes.join(' - ') : ('EPS ' + item.id);
  }

  handleTexto = (e) => {
    const { name, value } = e.target;
    this.setState({ form: { ...this.state.form, [name]: value } });
  }

  handleIdentificacion = (e) => {
    const soloNumeros = e.target.value.replace(/\D/g, '').slice(0, 15);
    this.setState({ form: { ...this.state.form, identification: soloNumeros }, pacienteExistente: false });
  }

  /** Enter dispara la búsqueda (no hace blur por sí solo); Tab/clic afuera ya lo cubre manejarBlurIdentificacion. */
  manejarTecladoIdentificacion = (e) => {
    if (e.key === 'Enter') this.buscarPaciente();
  }

  manejarBlurIdentificacion = () => {
    this.buscarPaciente();
  }

  handleTipoId = (opcion) => {
    this.setState({ form: { ...this.state.form, tipoId: opcion }, pacienteExistente: false }, () => {
      if (this.state.form.identification) this.buscarPaciente();
    });
  }

  /** Busca el paciente por tipo+número de identificación (mismo endpoint que Buscar_Paciente de Citas.js) y autocompleta lo que la respuesta traiga. */
  buscarPaciente = () => {
    const { form } = this.state;
    if (!form.tipoId || !form.identification) return;

    this.setState({ buscandoPaciente: true });
    axios.post(ApiURL + "/api/Patients/GetPatient", {
      identification: form.identification,
      typeId: form.tipoId.value
    })
      .then((response) => {
        console.log('GetPatient:', response.data);
        this.autocompletarDesdeRespuesta(response.data || {});
        this.setState({ buscandoPaciente: false, pacienteExistente: true });
        this.notificar('Atención', 'Este paciente ya se encuentra creado, se autocompletaron sus datos disponibles.', 'success');
      })
      .catch((error) => {
        this.setState({ buscandoPaciente: false, pacienteExistente: false });
        if (error.response && error.response.status !== 404) {
          const mensaje = (error.response.data && error.response.data.message) || 'No se pudo consultar el paciente';
          this.notificar('Atención', mensaje, 'danger');
        }
      });
  }

  /** Devuelve el primer valor no nulo probando varias posibles llaves (la respuesta de GetPatient no usa exactamente los mismos nombres que PreRegister). */
  primerValor = (obj, claves) => {
    for (let i = 0; i < claves.length; i++) {
      const valor = obj ? obj[claves[i]] : undefined;
      if (valor !== undefined && valor !== null && valor !== '') return valor;
    }
    return null;
  }

  /** El backend a veces referencia una relación como {id,...} y a veces como el id plano. */
  extraerId = (valor) => {
    if (valor === null || valor === undefined) return null;
    if (typeof valor === 'object') {
      if (valor.id !== undefined) return valor.id;
      if (valor.regimenId !== undefined) return valor.regimenId;
      if (valor.regimeId !== undefined) return valor.regimeId;
      if (valor.departmentId !== undefined) return valor.departmentId;
      if (valor.municipalityId !== undefined) return valor.municipalityId;
      if (valor.activityId !== undefined) return valor.activityId;
      if (valor.epsId !== undefined) return valor.epsId;
      return null;
    }
    return valor;
  }

  /** Busca una opción {value,label} por id tolerando diferencias de tipo (string vs number) entre lo que trae GetPatient y lo que trae el catálogo. */
  buscarOpcionPorId = (opciones, id) => {
    if (id === null || id === undefined || !opciones) return null;
    return opciones.find((o) => String(o.value) === String(id)) || null;
  }

  /** Respaldo cuando GetPatient no trae un id de la relación sino solo el nombre (ej. "regimen": "Contributivo"). */
  buscarOpcionPorNombre = (opciones, nombre) => {
    if (!nombre || !opciones) return null;
    const normalizado = String(nombre).trim().toLowerCase();
    return opciones.find((o) => String(o.label).trim().toLowerCase().startsWith(normalizado)) || null;
  }

  parseFechaNacimiento = (valor) => {
    if (!valor) return { dia: null, mes: null, anio: null };
    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor);
    if (m) return { anio: Number(m[1]), mes: Number(m[2]), dia: Number(m[3]) };
    m = /^(\d{2})-(\d{2})-(\d{4})/.exec(valor);
    if (m) return { dia: Number(m[1]), mes: Number(m[2]), anio: Number(m[3]) };
    return { dia: null, mes: null, anio: null };
  }

  /** Autocompleta el formulario con lo que traiga la respuesta de GetPatient (campo por campo, sin forzar los que no vengan). */
  autocompletarDesdeRespuesta = (data) => {
    const user = data.user || data || {};

    const genero = this.primerValor(user, ['gender']);
    const estadoCivil = this.primerValor(user, ['civilStatus', 'civil_status']);
    const parentesco = this.primerValor(user, ['relationshipPerson', 'relationship_person']);
    const { dia, mes, anio } = this.parseFechaNacimiento(this.primerValor(user, ['birthday', 'birthDate']));

    const idDepartamento = this.extraerId(this.primerValor(user, ['department', 'departmentId']));
    const idMunicipio = this.extraerId(this.primerValor(user, ['municipality', 'municipalityId']));
    const idActividad = this.extraerId(this.primerValor(user, ['activity', 'activityId']));
    const idEps = this.extraerId(this.primerValor(user, ['eps', 'epsId']));
    // GetPatient lo trae como "user.regime" (sin "n", a diferencia del resto
    // del panel que usa "regimen") con {id, nombre}.
    const regimenCrudo = this.primerValor(user, ['regime', 'regimeId']);
    const idRegimen = this.extraerId(regimenCrudo);
    // Respaldo si lo que llega es el nombre del régimen (string) en vez de un id.
    const nombreRegimen = typeof regimenCrudo === 'string'
      ? regimenCrudo
      : (regimenCrudo && typeof regimenCrudo === 'object' ? (regimenCrudo.nombre || regimenCrudo.name) : null);

    this.setState((previo) => ({
      form: {
        ...previo.form,
        name1: this.primerValor(user, ['name1']) || previo.form.name1,
        name2: this.primerValor(user, ['name2']) || previo.form.name2,
        lastName1: this.primerValor(user, ['lastname1', 'lastName1']) || previo.form.lastName1,
        lastName2: this.primerValor(user, ['lastname2', 'lastName2']) || previo.form.lastName2,
        gender: (genero && GENEROS.find((o) => o.value === genero)) || previo.form.gender,
        dia: (dia && DIAS.find((o) => o.value === dia)) || previo.form.dia,
        mes: (mes && MESES.find((o) => o.value === mes)) || previo.form.mes,
        anio: (anio && ANIOS.find((o) => o.value === anio)) || previo.form.anio,
        email: this.primerValor(user, ['email']) || previo.form.email,
        phone: this.primerValor(user, ['phone', 'telephone']) || previo.form.phone,
        address: this.primerValor(user, ['address']) || previo.form.address,
        activityId: this.buscarOpcionPorId(previo.actividades, idActividad) || previo.form.activityId,
        civilStatus: (estadoCivil && (ESTADOS_CIVILES.find((o) => o.value === estadoCivil) || { value: estadoCivil, label: estadoCivil })) || previo.form.civilStatus,
        personInCharge: this.primerValor(user, ['personInCharge', 'person_in_charge']) || previo.form.personInCharge,
        relationshipPerson: (parentesco && (PARENTESCOS.find((o) => o.value === parentesco) || { value: parentesco, label: parentesco })) || previo.form.relationshipPerson,
        phonePerson: this.primerValor(user, ['phonePerson', 'phone_person']) || previo.form.phonePerson,
        epsId: this.buscarOpcionPorId(previo.epsList, idEps) || previo.form.epsId,
        regimenId: this.buscarOpcionPorId(previo.regimenes, idRegimen) || this.buscarOpcionPorNombre(previo.regimenes, nombreRegimen) || previo.form.regimenId,
        departmentId: this.buscarOpcionPorId(previo.departamentos, idDepartamento) || previo.form.departmentId
      },
      // Por si estos catálogos aún no habían terminado de cargar cuando se
      // buscó al paciente: resolverIdsPendientes() los completa en cuanto
      // lleguen (ver cargarListas).
      idsRelacionPendientes: { departmentId: idDepartamento, activityId: idActividad, epsId: idEps, regimenId: idRegimen, regimenNombre: nombreRegimen }
    }));

    if (idDepartamento != null) this.cargarMunicipios(idDepartamento, idMunicipio);
  }

  handleTelefono = (e) => {
    const { name, value } = e.target;
    const soloNumeros = value.replace(/\D/g, '').slice(0, 10);
    this.setState({ form: { ...this.state.form, [name]: soloNumeros } });
  }

  handleSelect = (campo) => (opcion) => {
    this.setState({ form: { ...this.state.form, [campo]: opcion } });
  }

  handleDepartamento = (opcion) => {
    this.setState({
      form: { ...this.state.form, departmentId: opcion, municipalityId: null },
      municipios: []
    });
    if (opcion) this.cargarMunicipios(opcion.value);
  }

  cargarMunicipios = (idDepartamento, idMunicipioSeleccionar) => {
    this.setState({ cargandoMunicipios: true });
    axios.get(ApiURL + "/api/Departments/ListMunicipalties/" + idDepartamento)
      .then((response) => {
        const opciones = (response.data || []).map((item) => ({ value: item.id, label: item.nombre }));
        const municipioEncontrado = this.buscarOpcionPorId(opciones, idMunicipioSeleccionar);
        this.setState((previo) => ({
          municipios: opciones,
          cargandoMunicipios: false,
          form: municipioEncontrado ? { ...previo.form, municipalityId: municipioEncontrado } : previo.form
        }));
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargandoMunicipios: false });
      });
  }

  resetForm = () => {
    this.setState({ form: formInicial(), municipios: [], pacienteExistente: false, buscandoPaciente: false, idsRelacionPendientes: null });
  }

  /** Cierra sin guardar: descarta lo digitado (el botón "Cerrar" destruye el formulario). */
  cerrarModal = () => {
    this.resetForm();
  }

  notificar = (titulo, mensaje, tipo) => {
    store.addNotification({
      title: titulo,
      message: mensaje,
      type: tipo,
      container: 'top-right',
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 10000, showIcon: true }
    });
  }

  /** Extrae opcion.value, pero nunca deja pasar "undefined": si el catálogo trae un id con otro nombre y la opción quedó sin value, axios/JSON.stringify eliminaría la llave completa del payload. */
  valorSelect = (opcion, porDefecto) => {
    if (!opcion || opcion.value === undefined || opcion.value === null) return (porDefecto !== undefined ? porDefecto : null);
    return opcion.value;
  }

  /** Arma el "birthday" en ISO-8601 UTC (ej. 2026-10-05T00:00:00.000Z), que es lo que espera el backend al insertar. Date.UTC evita que la zona horaria del navegador corra la fecha. */
  construirBirthdayISO = () => {
    const { dia, mes, anio } = this.state.form;
    if (!dia || !mes || !anio) return '';
    return new Date(Date.UTC(anio.value, mes.value - 1, dia.value)).toISOString();
  }

  construirPayload = () => {
    const f = this.state.form;
    return {
      identification: f.identification,
      typeId: this.valorSelect(f.tipoId, ''),
      name1: f.name1,
      name2: f.name2,
      lastName1: f.lastName1,
      lastName2: f.lastName2,
      gender: this.valorSelect(f.gender, ''),
      birthday: this.construirBirthdayISO(),
      email: f.email,
      phone: f.phone,
      address: f.address,
      country: 'Colombia',
      departmentId: this.valorSelect(f.departmentId),
      municipalityId: this.valorSelect(f.municipalityId),
      activityId: this.valorSelect(f.activityId),
      civilStatus: this.valorSelect(f.civilStatus, ''),
      personInCharge: f.personInCharge,
      relationshipPerson: this.valorSelect(f.relationshipPerson, ''),
      phonePerson: f.phonePerson,
      epsId: this.valorSelect(f.epsId),
      regimenId: this.valorSelect(f.regimenId)
    };
  }

  /** Edad del paciente según día/mes/año elegidos, o null si la fecha aún no está completa. */
  calcularEdad = () => {
    const { dia, mes, anio } = this.state.form;
    if (!dia || !mes || !anio) return null;

    const hoy = new Date();
    const nacimiento = new Date(anio.value, mes.value - 1, dia.value);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const aunNoHaCumplidoEsteAnio = (hoy.getMonth() < nacimiento.getMonth())
      || (hoy.getMonth() === nacimiento.getMonth() && hoy.getDate() < nacimiento.getDate());
    if (aunNoHaCumplidoEsteAnio) edad--;
    return edad;
  }

  /** Menor de 18 o mayor de 70: los datos del acudiente dejan de ser opcionales. */
  requiereResponsable = () => {
    const edad = this.calcularEdad();
    return edad !== null && (edad < 18 || edad > 70);
  }

  /** Mensaje del aviso de acudiente obligatorio, según la edad ya calculada (menor de edad vs. adulto mayor). */
  mensajeResponsableObligatorio = () => {
    const edad = this.calcularEdad();
    if (edad === null) return '';
    if (edad < 18) return 'El paciente es menor de edad (' + edad + ' años): los datos del acudiente son obligatorios.';
    if (edad > 70) return 'El paciente es adulto mayor (' + edad + ' años): los datos del acudiente son obligatorios.';
    return '';
  }

  /** Qué tan obligatorios (CAMPOS_REQUERIDOS, + CAMPOS_RESPONSABLE si aplica por edad) quedaron sin diligenciar. */
  calcularCamposFaltantes = () => {
    const f = this.state.form;
    const faltantes = [];
    const requeridos = this.requiereResponsable() ? CAMPOS_REQUERIDOS.concat(CAMPOS_RESPONSABLE) : CAMPOS_REQUERIDOS;
    requeridos.forEach((campo) => {
      if (campo.clave === 'fechaNacimiento') {
        if (!f.dia || !f.mes || !f.anio) faltantes.push(campo.etiqueta);
        return;
      }
      const valor = f[campo.clave];
      const vacio = campo.tipo === 'select' ? !valor : (!valor || !String(valor).trim());
      if (vacio) faltantes.push(campo.etiqueta);
    });
    return faltantes;
  }

  /** El botón "Guardar" del modal "Crear paciente" solo se habilita con todos los obligatorios diligenciados. */
  formularioCompleto = () => this.calcularCamposFaltantes().length === 0;

  /**
   * Códigos de documento válidos por edad para colombianos, según RIPS:
   * 0-3m29d: RC/CN · 3m29d-7a: RC · 7a-18a: TI (RC hasta 7a11m29d) ·
   * 18a en adelante: CC (TI hasta 18a11m29d). Null si la fecha de
   * nacimiento aún no está completa.
   */
  codigosDocumentoValidosPorEdad = () => {
    const { dia, mes, anio } = this.state.form;
    if (!dia || !mes || !anio) return null;

    const hoy = new Date();
    const nacimiento = new Date(anio.value, mes.value - 1, dia.value);
    const sumarAFechaNacimiento = (anios, meses, dias) => {
      const f = new Date(nacimiento);
      f.setFullYear(f.getFullYear() + anios);
      f.setMonth(f.getMonth() + meses);
      f.setDate(f.getDate() + dias);
      return f;
    };

    if (hoy < sumarAFechaNacimiento(0, 3, 29)) return ['RC', 'CN'];
    if (hoy < sumarAFechaNacimiento(7, 0, 0)) return ['RC'];
    if (hoy < sumarAFechaNacimiento(7, 11, 29)) return ['TI', 'RC'];
    if (hoy < sumarAFechaNacimiento(18, 0, 0)) return ['TI'];
    if (hoy < sumarAFechaNacimiento(18, 11, 29)) return ['CC', 'TI'];
    return ['CC'];
  }

  /** El tipo de documento elegido corresponde a la edad (los de extranjero no tienen restricción de edad). */
  tipoDocumentoValidoParaEdad = () => {
    const { tipoId } = this.state.form;
    if (!tipoId) return true;
    if (esDocumentoExtranjero(tipoId.label)) return true;

    const codigosValidos = this.codigosDocumentoValidosPorEdad();
    if (!codigosValidos) return true; // aún no hay fecha de nacimiento completa

    return codigosValidos.includes(tipoId.value);
  }

  /** Mensaje de ayuda cuando el tipo de documento elegido no corresponde a la edad del paciente. */
  mensajeTipoDocumentoInvalido = () => {
    const codigosValidos = this.codigosDocumentoValidosPorEdad();
    if (!codigosValidos) return '';
    const etiquetas = codigosValidos.map((codigo) => ETIQUETAS_DOC_COLOMBIA[codigo] || codigo).join(' o ');
    return 'El tipo de documento no corresponde a la edad del paciente. Para su edad se espera: ' + etiquetas + '.';
  }

  /** Resumen de TODO el formulario (obligatorio y opcional) para la ventana de confirmación: lo que falta queda con valor vacío (se pinta en naranja). */
  obtenerResumenCampos = () => {
    const f = this.state.form;
    const fechaNacimiento = (f.dia && f.mes && f.anio) ? (f.dia.label + ' de ' + f.mes.label + ' de ' + f.anio.label) : '';
    return [
      { etiqueta: 'Tipo de identificación', valor: f.tipoId ? f.tipoId.label : '' },
      { etiqueta: 'Número de identificación', valor: f.identification },
      { etiqueta: 'Primer nombre', valor: f.name1 },
      { etiqueta: 'Segundo nombre', valor: f.name2 },
      { etiqueta: 'Primer apellido', valor: f.lastName1 },
      { etiqueta: 'Segundo apellido', valor: f.lastName2 },
      { etiqueta: 'Género', valor: f.gender ? f.gender.label : '' },
      { etiqueta: 'Fecha de nacimiento', valor: fechaNacimiento },
      { etiqueta: 'Estado civil', valor: f.civilStatus ? f.civilStatus.label : '' },
      { etiqueta: 'Ocupación', valor: f.activityId ? f.activityId.label : '' },
      { etiqueta: 'Correo electrónico', valor: f.email },
      { etiqueta: 'Teléfono', valor: f.phone },
      { etiqueta: 'Dirección', valor: f.address },
      { etiqueta: 'País', valor: 'Colombia' },
      { etiqueta: 'Departamento', valor: f.departmentId ? f.departmentId.label : '' },
      { etiqueta: 'Municipio', valor: f.municipalityId ? f.municipalityId.label : '' },
      { etiqueta: 'Nombre del responsable', valor: f.personInCharge },
      { etiqueta: 'Parentesco', valor: f.relationshipPerson ? f.relationshipPerson.label : '' },
      { etiqueta: 'Teléfono del responsable', valor: f.phonePerson },
      { etiqueta: 'EPS', valor: f.epsId ? f.epsId.label : '' },
      { etiqueta: 'Régimen', valor: f.regimenId ? f.regimenId.label : '' }
    ];
  }

  guardarPaciente = () => {
    if (this.state.pacienteExistente) {
      this.notificar('Atención', 'Este paciente ya se encuentra creado', 'info');
      return;
    }

    const f = this.state.form;
    if ((f.phone && f.phone.length !== 10) || (f.phonePerson && f.phonePerson.length !== 10)) {
      this.notificar('Atención', 'El teléfono debe tener 10 dígitos', 'danger');
      return;
    }

    if (!this.tipoDocumentoValidoParaEdad()) {
      this.notificar('Atención', this.mensajeTipoDocumentoInvalido(), 'danger');
      return;
    }

    // El botón ya viene deshabilitado mientras falte algo obligatorio; esta
    // es solo la última barrera antes de abrir la ventana de confirmación.
    if (!this.formularioCompleto()) {
      this.notificar('Atención', 'Faltan datos obligatorios por diligenciar', 'danger');
      return;
    }

    $('#modal-confirmar-registro-incompleto').modal('show');
    // El backdrop de este segundo modal se agrega DESPUÉS del que ya tiene
    // el modal "Crear paciente" abierto: sube el último para que no tape al
    // modal de confirmación que sí debe quedar encima.
    window.setTimeout(() => $('.modal-backdrop').last().css('z-index', 1055), 0);
  }

  /** El usuario confirmó "Estoy seguro" en la ventana de confirmación de registro. */
  confirmarGuardarIncompleto = () => {
    $('#modal-confirmar-registro-incompleto').modal('hide');
    this.procederGuardar();
  }

  procederGuardar = () => {
    const payload = this.construirPayload();
    this.setState({ guardando: true });

    axios.post(ApiURL + "/api/Patients/PreRegister", payload)
      .then((response) => {
        this.notificar('Mensaje', 'El paciente se creó correctamente', 'success');
        this.setState({ guardando: false });
        $('#modal-crear-paciente').modal('hide');
        const pacienteCreado = { ...payload, ...(response.data || {}) };
        this.resetForm();
        if (this.props.onPacienteCreado) this.props.onPacienteCreado(pacienteCreado);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && error.response.data.message) || 'No se pudo crear el paciente';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ guardando: false });
      });
  }

  render() {
    const { form } = this.state;

    return (
      <React.Fragment>
      <div className="modal fade" id="modal-crear-paciente" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content mcp-modal">

            <div className="modal-header mcp-modal__header">
              <h4 className="modal-title mcp-modal__title"><i className="fas fa-user-plus"></i> Crear paciente</h4>
              <button type="button" className="close mcp-modal__close" data-dismiss="modal" onClick={this.cerrarModal} aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body mcp-modal__body">

              <div className="mcp-section">
                <h6 className="mcp-section__titulo"><i className="fas fa-id-card"></i> Identificación</h6>

                {this.state.pacienteExistente ? (
                  <div className="alert alert-info mcp-alerta-existente">
                    <i className="fas fa-info-circle"></i> Este paciente ya se encuentra creado, se autocompletaron sus datos disponibles.
                  </div>
                ) : null}

                <div className="row mcp-row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Tipo de identificación: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={this.state.tiposId} value={form.tipoId} onChange={this.handleTipoId} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Número de identificación: <span className="mcp-requerido">*</span> {this.state.buscandoPaciente ? <i className="fas fa-circle-notch fa-spin"></i> : null}</label>
                      <input type="text" className="form-control" placeholder="Número de identificación" value={form.identification}
                        onChange={this.handleIdentificacion} onKeyDown={this.manejarTecladoIdentificacion} onBlur={this.manejarBlurIdentificacion} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mcp-section">
                <h6 className="mcp-section__titulo"><i className="fas fa-user"></i> Datos personales</h6>
                <div className="row mcp-row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Primer nombre: <span className="mcp-requerido">*</span></label>
                      <input type="text" className="form-control" name="name1" placeholder="Primer nombre" value={form.name1} onChange={this.handleTexto} />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Segundo nombre:</label>
                      <input type="text" className="form-control" name="name2" placeholder="Segundo nombre" value={form.name2} onChange={this.handleTexto} />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Primer apellido: <span className="mcp-requerido">*</span></label>
                      <input type="text" className="form-control" name="lastName1" placeholder="Primer apellido" value={form.lastName1} onChange={this.handleTexto} />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Segundo apellido:</label>
                      <input type="text" className="form-control" name="lastName2" placeholder="Segundo apellido" value={form.lastName2} onChange={this.handleTexto} />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Género: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={GENEROS} value={form.gender} onChange={this.handleSelect('gender')} />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Estado civil: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={ESTADOS_CIVILES} value={form.civilStatus} onChange={this.handleSelect('civilStatus')} />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Ocupación: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={this.state.actividades} value={form.activityId} onChange={this.handleSelect('activityId')} />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <label>Fecha de nacimiento: <span className="mcp-requerido">*</span></label>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <Select {...selectPropsComunes} placeholder="Día..." options={DIAS} value={form.dia} onChange={this.handleSelect('dia')} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <Select {...selectPropsComunes} placeholder="Mes..." options={MESES} value={form.mes} onChange={this.handleSelect('mes')} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <Select {...selectPropsComunes} placeholder="Año..." options={ANIOS} value={form.anio} onChange={this.handleSelect('anio')} />
                    </div>
                  </div>

                  {!this.tipoDocumentoValidoParaEdad() ? (
                    <div className="col-md-12">
                      <div className="alert alert-warning mcp-alerta-responsable">
                        <i className="fas fa-exclamation-triangle"></i> {this.mensajeTipoDocumentoInvalido()}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="mcp-section">
                <h6 className="mcp-section__titulo"><i className="fas fa-map-marker-alt"></i> Contacto</h6>
                <div className="row mcp-row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Correo electrónico: <span className="mcp-requerido">*</span></label>
                      <input type="email" className="form-control" name="email" placeholder="correo@ejemplo.com" value={form.email} onChange={this.handleTexto} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Teléfono: <span className="mcp-requerido">*</span></label>
                      <input type="text" maxLength="10" className="form-control" name="phone" placeholder="Teléfono" value={form.phone} onChange={this.handleTelefono} />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Dirección: <span className="mcp-requerido">*</span></label>
                      <input type="text" className="form-control" name="address" placeholder="Dirección" value={form.address} onChange={this.handleTexto} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>País:</label>
                      <select className="form-control" value="Colombia" onChange={() => {}}>
                        <option value="Colombia">Colombia</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Departamento: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={this.state.departamentos} value={form.departmentId} onChange={this.handleDepartamento} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Municipio: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={this.state.municipios} value={form.municipalityId} onChange={this.handleSelect('municipalityId')}
                        isDisabled={!form.departmentId} isLoading={this.state.cargandoMunicipios} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mcp-section">
                <h6 className="mcp-section__titulo"><i className="fas fa-hands-helping"></i> Acudiente / responsable</h6>
                {this.requiereResponsable() ? (
                  <div className="alert alert-warning mcp-alerta-responsable">
                    <i className="fas fa-info-circle"></i> {this.mensajeResponsableObligatorio()}
                  </div>
                ) : null}
                <div className="row mcp-row">
                  <div className="col-md-5">
                    <div className="form-group">
                      <label>Nombre del responsable: {this.requiereResponsable() ? <span className="mcp-requerido">*</span> : null}</label>
                      <input type="text" className="form-control" name="personInCharge" placeholder="Nombre del responsable" value={form.personInCharge} onChange={this.handleTexto} />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Parentesco: {this.requiereResponsable() ? <span className="mcp-requerido">*</span> : null}</label>
                      <Select {...selectPropsComunes} options={PARENTESCOS} value={form.relationshipPerson} onChange={this.handleSelect('relationshipPerson')} />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Teléfono del responsable: {this.requiereResponsable() ? <span className="mcp-requerido">*</span> : null}</label>
                      <input type="text" maxLength="10" className="form-control" name="phonePerson" placeholder="Teléfono" value={form.phonePerson} onChange={this.handleTelefono} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mcp-section">
                <h6 className="mcp-section__titulo"><i className="fas fa-notes-medical"></i> Afiliación en salud</h6>
                <div className="row mcp-row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>EPS: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={this.state.epsList} value={form.epsId} onChange={this.handleSelect('epsId')} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Régimen: <span className="mcp-requerido">*</span></label>
                      <Select {...selectPropsComunes} options={this.state.regimenes} value={form.regimenId} onChange={this.handleSelect('regimenId')} />
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className="modal-footer justify-content-between mcp-modal__footer">
              <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.cerrarModal}>Cerrar</button>
              <button type="button" className="btn btn-primary" disabled={this.state.guardando || this.state.pacienteExistente || !this.formularioCompleto() || !this.tipoDocumentoValidoParaEdad()} onClick={this.guardarPaciente}>
                {this.state.guardando ? <i className="fas fa-circle-notch fa-spin"></i> : null} Guardar
              </button>
            </div>

          </div>
        </div>
      </div>

      <div className="modal fade" id="modal-confirmar-registro-incompleto" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content mcp-modal mcp-modal--confirmacion">
            <div className="modal-header mcp-modal__header">
              <h4 className="modal-title mcp-modal__title"><i className="fas fa-clipboard-check"></i> Confirmar registro</h4>
            </div>
            <div className="modal-body mcp-modal__body">
              <p className="mcp-confirmar__intro">Revisa los datos del paciente antes de registrarlo (lo que quedó sin diligenciar aparece en naranja):</p>
              <div className="mcp-confirmar__resumen">
                {this.obtenerResumenCampos().map((campo) => (
                  <div key={campo.etiqueta} className={"mcp-confirmar__fila" + (!campo.valor ? " mcp-confirmar__fila--vacio" : "")}>
                    <span className="mcp-confirmar__etiqueta">{campo.etiqueta}</span>
                    <span className="mcp-confirmar__valor">{campo.valor || 'Sin diligenciar'}</span>
                  </div>
                ))}
              </div>
              <p className="mcp-confirmar__pregunta">¿Estás seguro de registrar al paciente con los datos diligenciados?</p>
            </div>
            <div className="modal-footer justify-content-between mcp-modal__footer">
              <button type="button" className="btn btn-danger" data-dismiss="modal">Cancelar</button>
              <button type="button" className="btn btn-primary" onClick={this.confirmarGuardarIncompleto}>Estoy seguro</button>
            </div>
          </div>
        </div>
      </div>
      </React.Fragment>
    );
  }
}

ModalCrearPaciente.propTypes = {
  onPacienteCreado: PropTypes.func
};

export default ModalCrearPaciente;
